module.exports = __webpack_public_path__ + "static/media/Shot-Injection-first-lithonia-medical-center.fb96a0d0.jpg";